<ngx-sonner-toaster position="top-right" />
@if (privatePage) {
  <router-outlet/>
} @else {
  <app-header/>
  <router-outlet/>
  <app-footer/>
  <app-consent-banner/>
}
